/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Theme } from "@mui/material";

export const linkLegalbirdStyle = {
  block: (theme: Theme) => ({
    "&:visited:not(:hover):not(:focus-visible)": {
      color: theme.palette.primary.main,
    },
  }),
};
